import { EnvironmentInjector, Injectable, runInInjectionContext } from '@angular/core';
import { collection, collectionData, deleteDoc, doc, docData, Firestore, setDoc } from '@angular/fire/firestore';
import { Observable, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LikeService {
  private readonly likesCountByPost = new Map<string, Observable<number>>();
  private readonly userLikedByKey = new Map<string, Observable<unknown>>();

  constructor(private _firestore: Firestore, private injector: EnvironmentInjector) {}

  getLikes(postId: string): Observable<number> {
    let obs = this.likesCountByPost.get(postId);
    if (!obs) {
      const likesRef = collection(this._firestore, `posts/${postId}/likes`);
      obs = runInInjectionContext(this.injector, () =>
        collectionData(likesRef).pipe(
          map((likes) => likes.length),
          shareReplay({ bufferSize: 1, refCount: false })
        )
      );
      this.likesCountByPost.set(postId, obs);
    }
    return obs;
  }

  likePost(postId: string, userId: string): void {
    const likeDocRef = doc(this._firestore, `posts/${postId}/likes/${userId}`);
    void setDoc(likeDocRef, { liked: true });
  }

  dislikePost(postId: string, userId: string): void {
    const likeDocRef = doc(this._firestore, `posts/${postId}/likes/${userId}`);
    void deleteDoc(likeDocRef);
  }

  userLiked(postId: string, userId: string): Observable<any> {
    const key = `${postId}:${userId}`;
    let obs = this.userLikedByKey.get(key);
    if (!obs) {
      const likeDocRef = doc(this._firestore, `posts/${postId}/likes/${userId}`);
      obs = runInInjectionContext(this.injector, () =>
        docData(likeDocRef).pipe(shareReplay({ bufferSize: 1, refCount: false }))
      );
      this.userLikedByKey.set(key, obs);
    }
    return obs as Observable<any>;
  }
}
